module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/3/5-7c4379481bb051f70fb728d40fb5249d.jpg";